import React, {useEffect, useState} from 'react';
import {SectionsProps} from "../../../../../models";
import {Formik} from "formik";
import {BusinessFormRequiredAssistanceValidation} from "../AddBusinessValidation";
import RadioField from "../../../../../components/radio-field/RadioField";
import {Button} from "../../../../../components";

export const RequiredAssistance: React.FC<SectionsProps> = ({
                                                                changeStep,
                                                                setNewBusinessInfo,
                                                                newBusinessInfo,
                                                                setSectionName
                                                            }) => {
    useEffect(() => {
        setSectionName('Required Assistance')
    }, [setSectionName]);

    const [assistance] = useState<Array<{ name: string }>>([
        {name: "Advocacy"},
        {name: "Financial Advise"},
        {name: "Business Counseling/Advice"},
        {name: "Business Plan Service"},
        {name: "Business Matching"},
        {name: "Local Expos Assistance"},
        {name: "International Expos Assistance"},
        {name: "Business Development"},
        {name: "Marketing & Promotion"},
        {name: "Product Design & Development"},
        {name: "Networking"},
        {name: "Management Consultancy/Training"},
        {name: "Other"},
    ])

    const [expos] = useState<Array<{ name: string }>>([
        {name: "Locally"},
        {name: "Internationally"},

    ])

    const [initialValues] = useState({
        required_assistance: newBusinessInfo?.required_assistance
    });


    const onSubmit = async (values: any, {setSubmitting}: any) => {
        setNewBusinessInfo && setNewBusinessInfo((prevInfo) => ({
            ...prevInfo,
            required_assistance: values.required_assistance
        }))

        changeStep && changeStep("next")
        setSubmitting(false);
    }
    return (
        <div className={'add-business-section'}>
            <p className={'info'}><span>Note:</span> Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. </p>
            <Formik
                validateOnMount={false}
                validateOnChange={true}
                initialValues={initialValues}
                validationSchema={BusinessFormRequiredAssistanceValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>
                        <div className={'add-business-section_input_radio'}>
                            <span>Business Assistance required?</span>
                            <div className={'add-business-section_input_radio_list'}>
                                {assistance.map(({name}, index) => (
                                    <RadioField
                                        key={index + "required_assistance" + name}
                                        id={'required_assistance.assistance'}
                                        name={'required_assistance.assistance'}
                                        text={name}
                                        onchange={handleChange}
                                        value={name}
                                        type={'checkbox'}
                                        checked={values.required_assistance.assistance
                                            .filter((selected) => (selected === name))[0] === name}
                                    />
                                ))}
                            </div>
                            <span id="--name__error" className="inputField_info_wrapper_message">
                                    {errors?.required_assistance?.assistance && touched?.required_assistance?.assistance && errors?.required_assistance?.assistance}
                                </span>
                        </div>

                        <div className={'add-business-section_input_radio'}>
                            <div className="add-business-section_border"/>
                            <span>Assistance with Expos?</span>
                            <div>
                                {expos.map(({name}, index) => (
                                    <RadioField
                                        key={index + "expos_assistance" + name}
                                        id={`required_assistance.expos_assistance.${name}`}
                                        name={'required_assistance.expos_assistance'}
                                        text={name}
                                        onchange={handleChange}
                                        value={name}
                                        checked={values.required_assistance.expos_assistance === name}
                                    />
                                ))}
                            </div>
                            <span id="--name__error" className="inputField_info_wrapper_message">
                                    {errors?.required_assistance?.expos_assistance && touched?.required_assistance?.expos_assistance && errors?.required_assistance?.expos_assistance}
                                </span>
                        </div>

                        <div className={'add-business-section_cta'}>

                            <Button type={"secondary"} onclick={() => changeStep && changeStep("prev")} text={"Prev"}/>
                            <Button type={"primary"} isSubmit={true} text={"Next"}/>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default RequiredAssistance;
